/** Minimum progress and elapsed time before an estimate is stable enough to show. */
const MIN_PERCENT = 3
const MIN_ELAPSED_MS = 3000

/** Seconds left, extrapolated from how far a task got in `elapsedMs`; null while it is too early to tell. */
export const estimateRemainingSeconds = (elapsedMs: number, percent: number): number | null => {
  if (percent < MIN_PERCENT || percent >= 100 || elapsedMs < MIN_ELAPSED_MS) return null
  return Math.max(1, Math.round((elapsedMs * (100 - percent)) / percent / 1000))
}

/** "45 s" or "2 min 10 s". */
export const formatRemaining = (seconds: number): string => {
  if (seconds < 60) return `${seconds} s`
  const minutes = Math.floor(seconds / 60)
  return `${minutes} min ${seconds % 60} s`
}
